<template >
  <div class="component-container">
    <app-navigation v-if="!$props.onlyMaps"></app-navigation>
    <div class="main-div">
      <form>
        <div class="demo text-left">
          <div class="p-2 header">
            <h3 class="text-left">Quantity discount</h3>
          </div>
          <div class="row mt-3">
            <div class="col-md-4">
              <div class="form-group">
                <label class="label text-left">Purchased items number</label>
                <input
                  type="number"
                  min="0"
                  v-model="quantity_discount.purchased_items"
                  class="form-control"
                  required
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="label text-left">Free Items Number</label>
                <input
                  type="number"
                  min="0"
                  v-model="quantity_discount.free_items"
                  class="form-control"
                  required
                />
              </div>
            </div>
            <div class="col-md-4">
              <button
                class="btn btn-primary float-right m-4"
                v-if="!formState.loading"
                type="button"
                @click="addQuantityDiscount"
              >
                Save
              </button>
              <button
                class="btn btn-primary float-right m-4"
                type="button"
                disabled
                v-else
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading
              </button>
            </div>
          </div>
        </div>
      </form>
      <form>
        <div class="demo text-left">
          <div class="p-2 header">
            <h3 class="text-left">General coupon</h3>
          </div>
          <div class="row mt-3">
            <div class="col-md-4">
              <div class="form-group">
                <label class="label text-left">coupon Name</label>
                <input
                  type="text"
                  v-model="coupon.name"
                  class="form-control"
                  required
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="label text-left">coupon Code</label>
                <input
                  type="text"
                  v-model="coupon.code"
                  class="form-control"
                  required
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="label text-left">discount type(..% or ..$)</label>
                <b-form-select
                  :disabled="formState.loading"
                  class="modified-dropdown form-control"
                  v-model="coupon.discount_type"
                  :options="['money', 'percent']"
                ></b-form-select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="label text-left">coupon discount (..%)</label>
                <input
                  type="number"
                  v-model="coupon.discount"
                  class="form-control"
                  required
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="label text-left">Start Date</label>
                <input
                  type="date"
                  v-model="coupon.start_date"
                  class="form-control"
                  required
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="label text-left">End Date</label>
                <input
                  type="date"
                  v-model="coupon.end_date"
                  class="form-control"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <button
          class="btn btn-primary float-right m-4"
          v-if="!formState.loading"
          @click="addCoupon"
        >
          Add Coupon
        </button>
        <button
          class="btn btn-primary float-right m-4"
          type="button"
          disabled
          v-else
        >
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading
        </button>
      </form>
      <div class="alert alert-danger" role="alert" v-if="formState.error">
        {{ formState.error }}
      </div>
      <table class="table mt-5">
        <thead class="thead-light table-striped table-hover">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Code</th>
            <th scope="col">discount type</th>
            <th scope="col">discount</th>
            <th scope="col">start date</th>
            <th scope="col">end date</th>
            <th scope="col">status</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="coupon in coupons" :key="coupon.id">
            <th scope="row">{{ coupon.id }}</th>
            <td>{{ coupon.name }}</td>
            <td>{{ coupon.code }}</td>
            <td>{{ coupon.discount_type }}</td>
            <td>{{ coupon.discount }}</td>
            <td>{{ coupon.start_date }}</td>
            <td>{{ coupon.end_date }}</td>
            <td>
              <span
                class="badge badge-danger"
                v-if="coupon.status == 'Not Active'"
                >{{ coupon.status }}</span
              >
              <span
                class="badge badge-success"
                v-if="coupon.status == 'Active'"
                >{{ coupon.status }}</span
              >
            </td>
            <td>
              <span
                class="badge badge-danger p-2"
                @click="deleteCoupon(coupon.id)"
                ><i class="fa fa-trash" aria-hidden="true"></i
              ></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Navigation from "../components/Navigation.vue";
import axios from "axios";
import { herokuUrl } from "../apiConfig";
import { getCookie } from "../cookie.js";
import logOut from "../scripts/utils";

export default {
  props: ["onlyMaps"],
  name: "Demo",

  data() {
    return {
      coupon: {},
      coupons: [],
      quantity_discount: {},
      formState: {
        loading: false,
        error: null,
      },
    };
  },
  mounted() {
    this.getCoupons();
  },
  methods: {
    addQuantityDiscount: function () {
      console.log("added", this.quantity_discount);
      return axios
        .post(`${herokuUrl}/create_discount`, this.quantity_discount, {
          headers: {
            Authorization: getCookie("user"),
          },
        })
        .then(() => {
          alert("Quantity discount Has Been Added Successfully");
          this.formState.loading = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert(
              "There was a problem when adding Quantity discount " +
                err.response.data.message
            );
          }
        });
    },
    getCoupons: function () {
      this.formState.loading = true;
      return Promise.all([
        axios.get(`${herokuUrl}/general_coupons`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        }),
      ])
        .then((res) => {
          console.log(res);
          this.coupons = res[0].data["general_coupons"];
          this.quantity_discount = res[0].data["quantity_discount"];
          this.formState.loading = false;
        })
        .catch((err) => {
          console.log(err);
          //   if (err.res.status == 401) {
          //       this.formState.loading = false;
          //     alert("coupons fetching failed, " + err.res.data.message);
          //     // logOut();
          //   } else {
          //     this.formState.loading = false;
          //     alert("coupons fetching failed, " + err.res.data.message);
          //   }
          // window.location.reload();
        });
    },
    addCoupon: function () {
      this.formState.loading = true;
      if (
        !this.coupon.name ||
        !this.coupon.code ||
        !this.coupon.discount ||
        !this.coupon.start_date ||
        !this.coupon.end_date ||
        !this.coupon.discount_type
      ) {
        this.formState.error = "All Fields Are Required";
        this.formState.loading = false;
        return;
      } else {
        console.log("submitted" + this.coupon);
        this.formState.loading = true;
        return axios
          .post(`${herokuUrl}/create_general_coupon`, this.coupon, {
            headers: {
              Authorization: getCookie("user"),
            },
          })
          .then(() => {
            alert("Coupon Has Been Added Successfully");
            this.coupon = {};
            this.getCoupons();
            this.formState.loading = false;
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert(
                "There was a problem when adding Coupon " +
                  err.response.data.message
              );
            }
          });
      }
    },
    deleteCoupon: function (id) {
      this.formState.loading = true;
      console.log("submitted" + id);
      return axios
        .post(
          `${herokuUrl}/delete_general_coupon`,
          { id: id },
          {
            headers: {
              Authorization: getCookie("user"),
            },
          }
        )
        .then(() => {
          alert("Coupon Has Been Deleted Successfully");
          this.coupon = {};
          this.getCoupons();
          this.formState.loading = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert(
              "There was a problem when Deleting Coupon " +
                err.response.data.message
            );
          }
        });
    },
  },

  components: {
    appNavigation: Navigation,
  },
};
</script>
<style lang='scss' scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.component-container {
  min-height: 100%;
  display: flex;
}

.main-div {
  padding: 50px;
  width: 80%;

  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }

  .header {
    padding-top: 16px !important;
    background: black;
    color: #b78b1e;
  }
}
</style>